"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * Until all browsers support the :focus-visible
 * pseudo-class, we apply a class to the body
 * element, and then style elements based
 * on those that're within scope of the body.
 *
 * We used to use the WICG focus-visible polyfill, but
 * React's reconciler could wipe the class that was applied to
 * components on state changes, removing the visual
 * indication of the focus ring. See
 * https://github.com/WICG/focus-visible/issues/211 for more.
 *
 * Focus rings will be shown by default. When we detect that the user is using
 * a mouse to interact with the page, we'll add a class to the <body> that
 * will hide focus rings on the page. If we later detect the user switched to
 * using the keyboard to interact with the page, we'll remove that class so
 * that focus rings will be shown. For users with JS disabled, this ensures
 * that focus rings are shown no matter what. If the user has JS enabled,
 * this provides progressive enhancement that hides focus rings for users who
 * are using a mouse.
 */
var initFocusRingListener = function initFocusRingListener() {
  function onKeyDown(e) {
    if (e.metaKey || e.altKey || e.ctrlKey) {
      return;
    }

    document.body.classList.remove('nw-hide-focus-ring');
  }

  function onMouseDown() {
    document.body.classList.add('nw-hide-focus-ring');
  }

  document.addEventListener('keydown', onKeyDown, true);
  document.addEventListener('mousedown', onMouseDown, true);
};

var _default = initFocusRingListener;
exports.default = _default;